import NewsRelease from './NewsRelease';
export default NewsRelease;
